import AdminHero from './Components/AdminHero';

const AdminHome = () => {
    return (
        <div className="">
            <AdminHero />
        </div>
    );
}

export default AdminHome;